module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-04-38cef91c403b424543a533576f2dc3ac.jpg";